<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'vant/lib/toast/style';
export default {
  name: 'App'
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .mb-8{
    margin-bottom: 8px;
  }
  .fade-enter,.fade-leave-active {
    opacity: 0;
  }
  .fade-enter-active,.fade-leave-active {
    transition: opacity 0.5s;
  }
  .tabbar-box{
    flex-shrink: 0;
    width: 100%;
    height: 49px;
    background: #FFFFFF;
    box-shadow: 0px -1px 5px 0px rgba(153, 153, 153, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .tabbar-item{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    color: #999999;
    width: 70px;
    height: 49px;
  }
  .tabbar-item:active{
    border-radius: 6px;
    background-color: #f4f4f4;
  }
  .tabbar-item img{
    width: 22px;
    height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue